<template>
    <div class="container">
      <v-card
        class="card"
        :style="{
          width: isMobile ? '100%' : '70%',
          padding: isMobile ? '10px' : '0px',
          height: isMobile ? '700px' : '460px',
          borderRadius: isMobile ? '0px' : '0px',
          marginTop: isMobile ? '0px' : '0px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center'
        }"
        style="
        background-color: #FFFFFF;
        "
        elevation="0"
      >

      <div class="text-section" style="flex: 1;">
          <div
          :style="{
            fontSize: isMobile ? '30px' : '22px',
            fontWeight: isMobile ? '900' : '900',
          }">
            넥스트클라우드 오피스
          </div>
  
            <div
              :style="{
                fontSize: isMobile ? '15px' : '15px',
                fontWeight: isMobile ? '100' : '500',
                paddingTop: '20px',
              }"
            >
              Nextcloud Office는 협업 편집이 가능한 강력한 LibreOffice 기반 온라인 오피스 제품군으로 주요 문서, 스프레드시트 및 프레젠테이션 파일 형식을 모두 지원하며 모든 최신 브라우저에서 작동합니다.
            </div><br>
            <div
              :style="{
                fontSize: isMobile ? '14px' : '15px',
                fontWeight: isMobile ? '100' : '500',
              }"
            >
              온라인 오피스를 제공합니다.
            </div>
            
        </div>
        <div class="image-section" style="flex: 1; display: flex; justify-content: center;">
          <img src="/images/nextcloud/nextcloud-office-preview.png" :width="isMobile ? '700' : '700'">
        </div>
  
      </v-card>
    </div>
  </template>
  
  <script>
  import { useRouter } from 'vue-router';
  import { ref, computed, onMounted } from 'vue';
  
  export default {
    setup() {
      const router = useRouter();
      const isMobile = ref(false);
  
      const checkIsMobile = () => {
        isMobile.value = window.innerWidth <= 768; // Check if the window width is less than or equal to 768px
      };
  
      const goToestimate = () => {
        router.push('/estimate');
      }
  
      onMounted(() => {
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
      });
  
      return {
        goToestimate,
        isMobile: computed(() => isMobile.value),
        isDesktop: computed(() => !isMobile.value),
      };
    },
  };
  </script>
  
  <style scoped>
  .container {
    display: flex;
    justify-content: center;
  }
  
  
  
  /* Styles for mobile */
  @media screen and (max-width: 768px) {
    .text-section {
      padding: 0px 20px 0 20px;
    }
  }
  </style>
  